
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5iRsI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");




const $24902acfefadcb18$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    subHeading: {
        id: "blog-posts-macro.sub-heading",
        defaultMessage: "Blog Posts"
    },
    createdBy: {
        id: "blog-posts-macro.created-by",
        defaultMessage: "created by"
    },
    emptyHeading: {
        id: "blog-posts-macro.empty-heading",
        defaultMessage: "Blog stream"
    },
    emptyContent: {
        id: "blog-posts-macro.empty-content",
        defaultMessage: "Create a blog post to share news and announcements with your team and company."
    },
    createPost: {
        id: "blog-posts-macro.create-post",
        defaultMessage: "Create blog post"
    },
    error: {
        id: "blog-posts-macro.error",
        defaultMessage: "Unable to display blog posts."
    },
    loading: {
        id: "blog-posts-macro.loading",
        defaultMessage: "Loading blog posts\u2026"
    },
    postedBy: {
        id: "blog-posts-macro.posted-by",
        defaultMessage: "{author} posted on {date}"
    },
    excerptPostedOn: {
        id: "blog-posts-macro.excerpt-posted-on",
        defaultMessage: "posted on {date}"
    },
    loadMore: {
        id: "blog-posts-macro.load-more",
        defaultMessage: "Load more blogs..."
    }
});






var $gLc6G = parcelRequire("gLc6G");


var $f9Oe5 = parcelRequire("f9Oe5");





var $jMyy4 = parcelRequire("jMyy4");




const $41c5e05b9a8c19b6$export$7a795ea2fa184b71 = (params, currentSpaceKey)=>{
    const variables = (0, $cozmU.useMemo)(()=>(0, $gLc6G.buildQueryVariables)(params, currentSpaceKey), [
        currentSpaceKey,
        params
    ]);
    const maxResults = (0, $gLc6G.getMaxResults)(params);
    const [loadMoreError, setLoadMoreError] = (0, $cozmU.useState)();
    const [isLoadingMore, setIsLoadingMore] = (0, $cozmU.useState)(false);
    const { data: data, error: error, loading: loading, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)((0, $f9Oe5.default), {
        variables: variables,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-first',
        __callerPackage__: "blog-posts-macro"
    });
    const loadedCount = data?.search?.nodes?.length ?? 0;
    const remainingCount = Math.max(maxResults - loadedCount, 0);
    const pageInfo = data?.search?.pageInfo;
    const isInitialLoading = loading && !data?.search;
    const canLoadMore = variables.includeEntireBody && remainingCount > 0 && Boolean(pageInfo?.hasNextPage) && Boolean(pageInfo?.endCursor);
    const loadMore = (0, $cozmU.useCallback)(async ()=>{
        const endCursor = pageInfo?.endCursor;
        if (!canLoadMore || !endCursor || loading || isLoadingMore) return;
        setLoadMoreError(undefined);
        setIsLoadingMore(true);
        await fetchMore({
            variables: {
                after: endCursor,
                first: Math.min((0, $gLc6G.ENTIRE_MODE_PAGE_SIZE), remainingCount)
            },
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult?.search) return prev;
                return {
                    ...prev,
                    search: {
                        ...prev.search ?? {},
                        count: fetchMoreResult.search.count ?? prev.search?.count ?? null,
                        nodes: [
                            ...prev.search?.nodes ?? [],
                            ...fetchMoreResult.search.nodes ?? []
                        ],
                        pageInfo: fetchMoreResult.search.pageInfo
                    }
                };
            }
        }).catch((err)=>{
            setLoadMoreError(err instanceof Error ? err : new Error(String(err)));
        }).finally(()=>{
            setIsLoadingMore(false);
        });
    }, [
        canLoadMore,
        fetchMore,
        isLoadingMore,
        loading,
        pageInfo?.endCursor,
        remainingCount
    ]);
    return {
        data: data,
        error: error,
        loading: isInitialLoading,
        cql: variables.cql,
        hasNextPage: canLoadMore,
        isLoadingMore: isLoadingMore,
        loadMore: canLoadMore ? loadMore : undefined,
        loadMoreError: loadMoreError
    };
};


const $5c663987d2c4a146$var$buildMacroParameters = (macroParams)=>({
        content: macroParams?.content?.value,
        time: macroParams?.time?.value,
        labels: macroParams?.labels?.value ?? macroParams?.label?.value,
        spaces: macroParams?.spaces?.value ?? macroParams?.space?.value,
        max: macroParams?.max?.value ?? macroParams?.maxResults?.value,
        sort: macroParams?.sort?.value,
        reverse: macroParams?.reverse?.value,
        author: macroParams?.author?.value
    });
const $5c663987d2c4a146$export$5d6b4e71896e8f23 = (macroParams)=>macroParams?.content?.value ?? 'entire';
const $5c663987d2c4a146$export$bcd1293b3c1159b6 = (macroParams, macroDefaultProps)=>{
    const spaceKey = macroDefaultProps.spaceKey;
    const contentMode = $5c663987d2c4a146$export$5d6b4e71896e8f23(macroParams);
    const { data: data, error: error, hasNextPage: hasNextPage, isLoadingMore: isLoadingMore, loadMore: loadMore, loadMoreError: loadMoreError, loading: loading } = (0, $41c5e05b9a8c19b6$export$7a795ea2fa184b71)(macroParams ?? {}, spaceKey);
    const nodes = (0, $cozmU.useMemo)(()=>(data?.search?.nodes ?? []).filter((0, $gLc6G.isBlogPostNode)), [
        data?.search?.nodes
    ]);
    const dataMacroParameters = (0, $cozmU.useMemo)(()=>$5c663987d2c4a146$var$buildMacroParameters(macroParams), [
        macroParams
    ]);
    const serializedMacroParameters = (0, $cozmU.useMemo)(()=>JSON.stringify(dataMacroParameters), [
        dataMacroParameters
    ]);
    return {
        contentMode: contentMode,
        data: data,
        error: error,
        hasNextPage: hasNextPage,
        isLoadingMore: isLoadingMore,
        loadMore: loadMore,
        loadMoreError: loadMoreError,
        loading: loading,
        nodes: nodes,
        serializedMacroParameters: serializedMacroParameters,
        spaceKey: spaceKey
    };
};


/* TitlesList.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");








var $I7hWB = parcelRequire("I7hWB");


var $d4GYd = parcelRequire("d4GYd");


var $7vK9E = parcelRequire("7vK9E");








var $a6t12 = parcelRequire("a6t12");


var $jJK3p = parcelRequire("jJK3p");


var $bQm3c = parcelRequire("bQm3c");





const $5dc99b02bed969e7$var$styles = {
    listContainer: "_0xmtkogVvo",
    subHeading: "_2R4pr3OeNX _1UtDYzKGUX",
    titlesUl: "_4FKVYEPgdg _0aNu0LYbGa",
    blogItem: "_4bt5LAnQyn _2WAcuGnQyn _4c065U2ADO _2Y7lL4gVvo _2R4pr3OeNX _43nrzTPgdg _1eOmH6o126",
    titleRow: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLchRC _37wbyuI7V3 _3TGfC9HnLE",
    leftMeta: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLchRC _2O5Vij7dHp _1bHrqERxCJ _4ouGXIdnbC _3TGfC9HnLE",
    rightMeta: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuz9WS _0GTcwRIZbP _3TGfC9HnLE",
    blogIcon: "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC _1UtDYzZpcK",
    titleLinkGroup: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLQame _4ouGXIdnbC _1EqgXlN91d",
    titleTextGroup: "_3iDTPbvLZJ _4ouGXIdnbC _3zvHkHdC7N",
    titleAnchor: "_3zvHkHdC7N",
    subtleAnchor: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzKGUX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};
const $5dc99b02bed969e7$export$9c7aae348aeccd51 = ({ nodes: nodes })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "blog-posts-titles-list",
        className: (0, $hekY6.default)([
            $5dc99b02bed969e7$var$styles.listContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5dc99b02bed969e7$var$styles.subHeading
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).subHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5dc99b02bed969e7$var$styles.titlesUl
    }, nodes.map((node)=>{
        const content = node.content;
        if (!content) return null;
        const createdDate = (0, $gLc6G.getCreatedDate)(node);
        const authorName = (0, $gLc6G.getAuthorName)(node);
        const authorAccountId = (0, $gLc6G.getAuthorAccountId)(node);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: content.id,
            xcss: $5dc99b02bed969e7$var$styles.blogItem,
            testId: "blog-post-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.titleRow
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.leftMeta
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.titleLinkGroup
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.blogIcon
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
            label: "",
            color: "currentColor"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.titleTextGroup
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: (0, $gLc6G.getContentUrl)(node),
            xcss: $5dc99b02bed969e7$var$styles.titleAnchor
        }, content.title), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            color: "color.text.subtlest"
        }, intl.formatMessage((0, $24902acfefadcb18$export$a7357cdd1f0b0168).createdBy)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: authorAccountId,
            fullName: authorName,
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
            userId: authorAccountId,
            fullName: authorName,
            behavior: "link",
            isUnderlinedByDefault: false,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- style overrides to match legacy macro subtle link styling
                color: "var(--ds-text-subtlest, #6B6E76)"
            }
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.rightMeta
            ])
        }, Boolean(content.space?.name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: (0, $gLc6G.getSpaceUrl)(node),
            xcss: $5dc99b02bed969e7$var$styles.subtleAnchor,
            testId: "blog-post-space-link"
        }, content.space?.name), Boolean(createdDate) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, (0, $gLc6G.formatSmartDate)(createdDate, intl, timeZone)))));
    })));
};


/* ExcerptsList.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $arQY7 = parcelRequire("arQY7");





var $4ez2K = parcelRequire("4ez2K");


var $1l0kj = parcelRequire("1l0kj");
























var $dF6Hu = parcelRequire("dF6Hu");

const $ea3d6e5aceb5d616$export$af9dc05418a334e = ({ atlasDocFormat: atlasDocFormat, mediaToken: mediaToken, contentId: contentId, spaceKey: spaceKey, spaceId: spaceId, RendererWrapper: RendererWrapper, fallback: fallback = null })=>{
    const adfDocument = (0, $cozmU.useMemo)(()=>{
        return atlasDocFormat ? (0, $dF6Hu.parseNestedAdfDocument)(atlasDocFormat) : null;
    }, [
        atlasDocFormat
    ]);
    if (adfDocument) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RendererWrapper, {
        adf: adfDocument.content,
        targetContentId: contentId,
        targetSpaceKey: spaceKey,
        targetSpaceId: spaceId,
        mediaToken: mediaToken ?? undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fallback);
};


/* LabelsList.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $IOtUu = parcelRequire("IOtUu");


var $3DjKS = parcelRequire("3DjKS");




const $bc0342895ad69cf4$var$styles = {
    labelsContainer: "_46hvQm2ADO"
};
const $bc0342895ad69cf4$export$2d4801a6a75948a8 = ({ labels: labels, spaceKey: spaceKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "blog-post-labels",
        className: (0, $hekY6.default)([
            $bc0342895ad69cf4$var$styles.labelsContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3DjKS.default), null, labels.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            key: label,
            text: label,
            href: (0, $gLc6G.getLabelUrl)(label, spaceKey),
            color: "standard",
            testId: "blog-post-label",
            isRemovable: false
        }))));


const $fe30a19c14203e0b$var$styles = {
    excerptListingContainer: "_4c065UNHnM _2R4pr3OeNX",
    excerptTitle: "_2sNsIgxzFw _0rIjykFQfX",
    excerptTitleLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8",
    excerptMeta: "_2mHwu81Y8M _0rIjyk2ADO _43nrzTFQfX _3iDTPbQ4SZ _0hPCNLDIqT _3TGfC9HnLE"
};
const $fe30a19c14203e0b$export$d55fd724d7ffd08 = ({ nodes: nodes, contentMode: contentMode, RendererWrapper: RendererWrapper })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "blog-posts-excerpts-list"
    }, nodes.map((node)=>{
        const content = node.content;
        if (!content) return null;
        const createdDate = (0, $gLc6G.getCreatedDate)(node);
        const avatarUrl = (0, $gLc6G.getAuthorAvatarUrl)(node);
        const authorName = (0, $gLc6G.getAuthorName)(node);
        const authorAccountId = (0, $gLc6G.getAuthorAccountId)(node);
        const labels = (0, $gLc6G.getLabels)(node);
        const spaceKey = content.space?.key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: content.id,
            "data-testid": "blog-post-item",
            className: (0, $hekY6.default)([
                $fe30a19c14203e0b$var$styles.excerptListingContainer
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.200",
            alignItems: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: authorAccountId,
            fullName: authorName,
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarUrl,
            size: "large",
            name: authorName
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $fe30a19c14203e0b$var$styles.excerptTitle
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: (0, $gLc6G.getContentUrl)(node),
            xcss: $fe30a19c14203e0b$var$styles.excerptTitleLink
        }, content.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $fe30a19c14203e0b$var$styles.excerptMeta
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "baseline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: authorAccountId,
            fullName: authorName,
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
            userId: authorAccountId,
            fullName: authorName,
            behavior: "link",
            isUnderlinedByDefault: false,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- style overrides to match legacy macro subtle link styling
                font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
            }
        })), Boolean(createdDate) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small"
        }, intl.formatMessage((0, $24902acfefadcb18$export$a7357cdd1f0b0168).excerptPostedOn, {
            date: (0, $gLc6G.formatBlogDate)(createdDate, intl, timeZone)
        })))))), contentMode === 'entire' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea3d6e5aceb5d616$export$af9dc05418a334e), {
            atlasDocFormat: content.body?.atlas_doc_format?.value,
            mediaToken: content.body?.atlas_doc_format?.mediaToken?.token,
            contentId: content.id ?? '',
            spaceKey: content.space?.key ?? '',
            spaceId: content.space?.id ?? undefined,
            RendererWrapper: RendererWrapper
        }), contentMode === 'excerpts' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea3d6e5aceb5d616$export$af9dc05418a334e), {
            atlasDocFormat: content.macroExcerpt?.atlasDocFormat,
            mediaToken: content.body?.atlas_doc_format?.mediaToken?.token,
            contentId: content.id ?? '',
            spaceKey: content.space?.key ?? '',
            spaceId: content.space?.id ?? undefined,
            RendererWrapper: RendererWrapper,
            fallback: content.excerpt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, content.excerpt) : null
        }), labels.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bc0342895ad69cf4$export$2d4801a6a75948a8), {
            labels: labels,
            spaceKey: spaceKey
        })));
    }));
};


/* EmptyState.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $eKMV3 = parcelRequire("eKMV3");














var $1NBp8 = parcelRequire("1NBp8");


const $590573fe5e39b249$var$blogPostsEmptyBg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALoAAADwCAMAAACAE47JAAAACVBMVEX///9wcHBwcHDMVYRVAAAAA3RSTlMAESJ8z6YqAAADxklEQVR42u3d0W4bMQxE0bn8/4/uQwMs2gXiLCVqyHbn3drjAQMlsKzod4i/AgBqH+LbAIyUXwGayge+gcgE2pQ+0h9rAS99KD/2BCz0qfrYGgz0ifooCAb6LH2UBQN9Cj5qg4E+AB8HgoHeGx8xFh/nMpgegYHeEh+ng5/ux0eMxYcng+mBke7HR4zFhzWD6YGD7seHP4PpgYHuxcdce8RYfMy1R4zFx1x79EoHejYk6POKp5+dcrrfHh0z2c6/b2ewXXylFV7JdHgnaDGA1z7zDaBtgab2lhuwdofBdgkM9mnlo5qAwT5Ij+rCYLvEYLtgnv0Kg+1isF1isF0MtovBdjHYLgbbRbzHnS12DPa+eDQXr5OZbGewXbz2yz4Vr7l2aSxec+1yZDBdWOl+u1wZTBdz6WIuXeyiOy7J2EHHdE/GMh3fNROs0eNjoKH95y+GZvZn8waN7M9fCU3sV+lOfZ7u1yfp2WC2S7EQ6u2f6X58nu7H5+l+fZ7ux6fpfjxpuh9Pmu7H46JHnLS3u8aJNN2Pz9P9U5On+4tP0/148nS/PU3340nT/XYzPaLW3vXKMgrpfrvU9ex5nu4vPkE32v8Iebrfnqb7Bz5N99upofvtUnS2t6AHSoQKut8u0due/izJb+c7OkPvr9Fcu6TuM8O3dInG9p/vFACt9iaeLgR0safWgb52fQ7Y7SysgvlHda0AnHaW6BJGe4Jepd9Qu/Ec9GrtkgnP8lOVCQ57gl6GX32ksjlv30YXp0eGG92IZ6l27/n5paq0Foy1a5KdG905NAvPch/+x0C32NlNl46NzH66HLVrUzhfu/x2DHSHnRvda8/VLrc9X7vc9nztamEnT6+376udIro4V7ua2DvQVV47ZXSdql1d7LSgU1w7dXRxpPZG3zvuQdeJiWn0tWN60HVgYtTIThM6lbVTSlf5xKiTnS50iifm87EAMNSepLPrQDGlE3OnY/1nbwt0Eo0Yar/TKTgLUjfsN/mOhRfsOXpiZR9dEU+fUj3tJOiJWswTcz2ixk45PR6ktnYe0in8mLZs2G/V2Gt/Ro8otFNJJzGP/onhKr2s9kI6Ea1q9//tfsVAbz4xElFdOy/9lkjFOuzz6Ryg04pOYe289P+dTjzKS99C10vfsyVV0ulE56VvGHbm0vU0NcUY6MZfwHDT87XLTM/Xjpuer73+Mtiq2nHT87XLTM/bZabnV6YZXWTlfrrIyv10kZX76aJQLpl3ay3EunGgleC7VQ4tJlf6Oh6tx3E7MdoTEvJM+Ip2hp3wX1/Ls3M7es6xAAAAAElFTkSuQmCC';
const $590573fe5e39b249$var$styles = {
    container: "_30huDKOeNX _0bjKvDKxmn _4kiQYAJWTS _2z4m57UZDI _1DJ2rVN91d"
};
const $590573fe5e39b249$export$fddf379e22a74b00 = ({ spaceKey: spaceKey })=>{
    const createBlogPostHref = spaceKey ? (0, $1NBp8.CREATE_CONTENT).toUrl({
        spaceKey: spaceKey,
        contentType: 'blog'
    }, {
        query: {
            spaceKey: spaceKey,
            withFallback: true,
            source: 'blog-posts-macro'
        }
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.300",
        testId: "blog-posts-empty-state",
        backgroundColor: "color.background.neutral.subtle",
        xcss: $590573fe5e39b249$var$styles.container,
        style: {
            backgroundImage: `url(${$590573fe5e39b249$var$blogPostsEmptyBg})`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).emptyHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).emptyContent)), createBlogPostHref && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "default",
        href: createBlogPostHref,
        testId: "create-blog-post-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).createPost)))));
};


const $944ec36b0e65d112$var$BlogPostsMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams, RendererWrapper: RendererWrapper })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { contentMode: contentMode, error: error, hasNextPage: hasNextPage, isLoadingMore: isLoadingMore, loadMore: loadMore, loadMoreError: loadMoreError, loading: loading, nodes: nodes, serializedMacroParameters: serializedMacroParameters, spaceKey: spaceKey } = (0, $5c663987d2c4a146$export$bcd1293b3c1159b6)(macroParams, macroDefaultProps);
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.300",
        testId: "blog-posts-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        label: formatMessage((0, $24902acfefadcb18$export$a7357cdd1f0b0168).loading)
    })));
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.300",
        testId: "blog-posts-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes,
        error: error
    }));
    let content;
    if (nodes.length === 0) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $590573fe5e39b249$export$fddf379e22a74b00), {
        spaceKey: spaceKey
    });
    else if (contentMode === 'titles') content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dc99b02bed969e7$export$9c7aae348aeccd51), {
        nodes: nodes
    });
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe30a19c14203e0b$export$d55fd724d7ffd08), {
        nodes: nodes,
        contentMode: contentMode,
        RendererWrapper: RendererWrapper
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-fabric-macro": attributes?.macroId,
        "data-macro-body": "",
        "data-macro-parameters": serializedMacroParameters,
        "data-testid": "blog-posts-macro"
    }, content, contentMode === 'entire' && hasNextPage && loadMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: loadMore,
        isLoading: isLoadingMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).loadMore))), loadMoreError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
const $944ec36b0e65d112$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).error);
const $944ec36b0e65d112$export$5725dc22f3c5370a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $944ec36b0e65d112$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($944ec36b0e65d112$var$BlogPostsMacroRendererComponent, props));
module.exports["BlogPostsMacroRenderer"] = $944ec36b0e65d112$export$5725dc22f3c5370a;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("jJK3p", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $a6t12 = parcelRequire("a6t12");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $buxP3.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $kSwu1.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $kSwu1.useIntl)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== style || $[13] !== teamsAppPersonProfileUrl || $[14] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: teamsAppPersonProfileUrl,
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = style;
        $[13] = teamsAppPersonProfileUrl;
        $[14] = userId;
        $[15] = t7;
    } else t7 = $[15];
    const renderNameComponent = t7;
    let t8;
    if ($[16] !== fullName || $[17] !== hasViewUserProfilePermission || $[18] !== isAnonymous || $[19] !== renderNameComponent || $[20] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, fullName)));
        $[16] = fullName;
        $[17] = hasViewUserProfilePermission;
        $[18] = isAnonymous;
        $[19] = renderNameComponent;
        $[20] = userId;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $8lYIw = parcelRequire("8lYIw");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    let t0;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== to || $[8] !== url) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            href: url,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = to;
        $[8] = url;
        $[9] = t0;
    } else t0 = $[9];
    return t0;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("3DjKS", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iODl6 = parcelRequire("iODl6");


var $iDrrr = parcelRequire("iDrrr");

const $ad9913fe9e202296$var$tagMotionCapability = Symbol.for('@atlaskit/tag/motion-capable');
const $ad9913fe9e202296$var$isMotionCapableTag = (child)=>{
    if (!/*#__PURE__*/ (0, $cozmU.isValidElement)(child)) return false;
    const childType = child.type;
    return (typeof childType === 'function' || typeof childType === 'object' && childType !== null) && Reflect.get(childType, $ad9913fe9e202296$var$tagMotionCapability) === true;
};
const $ad9913fe9e202296$var$baseStyles = null;
const $ad9913fe9e202296$var$justifyStartStyles = null;
const $ad9913fe9e202296$var$justifyEndStyles = null; /**
                                * __Tag group__
                                *
                                * A tag group controls the layout and alignment for a collection of tags.
                                *
                                * - [Examples](https://atlassian.design/components/tag-group/examples)
                                * - [Code](https://atlassian.design/components/tag-group/code)
                                * - [Usage](https://atlassian.design/components/tag-group/usage)
                                */ 
const $ad9913fe9e202296$var$TagGroup = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(15);
    const { alignment: t1, titleId: titleId, label: label, children: children } = t0;
    const alignment = t1 === undefined ? "start" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $iDrrr.fg)("platform-dst-motion-uplift-labels");
        $[0] = t2;
    } else t2 = $[0];
    const isTagMotionEnabled = t2;
    let t3;
    if ($[1] !== children) {
        t3 = isTagMotionEnabled && (0, $cozmU.Children).toArray(children).every($ad9913fe9e202296$var$isMotionCapableTag);
        $[1] = children;
        $[2] = t3;
    } else t3 = $[2];
    const shouldProvideMotionBoundary = t3;
    const t4 = alignment === "start" && "_37wbyuchRC";
    const t5 = alignment === "end" && "_37wbyuz9WS";
    let t6;
    if ($[3] !== t4 || $[4] !== t5) {
        t6 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02N91d _3TGfC9HnLE",
            t4,
            t5
        ]);
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== children || $[7] !== shouldProvideMotionBoundary) {
        t7 = shouldProvideMotionBoundary ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
            children: children
        }) : children;
        $[6] = children;
        $[7] = shouldProvideMotionBoundary;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== label || $[10] !== ref || $[11] !== t6 || $[12] !== t7 || $[13] !== titleId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            role: "group",
            ref: ref,
            "aria-label": label,
            "aria-labelledby": titleId,
            className: t6,
            children: t7
        });
        $[9] = label;
        $[10] = ref;
        $[11] = t6;
        $[12] = t7;
        $[13] = titleId;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    const isTagMotionEnabled = (0, $iDrrr.fg)('platform-dst-motion-uplift-labels');
    const shouldProvideMotionBoundary = isTagMotionEnabled && (0, $cozmU.Children).toArray(children).every($ad9913fe9e202296$var$isMotionCapableTag);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02N91d _3TGfC9HnLE",
            alignment === 'start' && "_37wbyuchRC",
            alignment === 'end' && "_37wbyuz9WS"
        ]),
        children: shouldProvideMotionBoundary ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
            children: children
        }) : children
    });
});
var $ad9913fe9e202296$export$2e2bcd8739ae039 = $ad9913fe9e202296$var$TagGroup;
module.exports["default"] = $ad9913fe9e202296$export$2e2bcd8739ae039;

});

parcelRegister("eZ4zi", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dce38ffecfe5cc1b$var$MINUTE = 60000;
const $dce38ffecfe5cc1b$var$HOUR = 3600000;
const $dce38ffecfe5cc1b$var$DAY = 86400000;
const $dce38ffecfe5cc1b$var$WEEK = 604800000;
const $dce38ffecfe5cc1b$var$MONTH = 2592000000;
const $dce38ffecfe5cc1b$var$YEAR = 31536000000;
const $dce38ffecfe5cc1b$export$5a00511f040384d7 = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit'
});
const $dce38ffecfe5cc1b$export$406508d2ca449bd = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
const $dce38ffecfe5cc1b$export$d2d0bf9c4d577e53 = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "macro-utils.relative-time-just-now",
        defaultMessage: "just now"
    },
    minutesAgo: {
        id: "macro-utils.relative-time-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    hoursAgo: {
        id: "macro-utils.relative-time-hours-ago",
        defaultMessage: "{hourCount, plural, one {{hourCount} hour ago} other {{hourCount} hours ago}}"
    },
    daysAgo: {
        id: "macro-utils.relative-time-days-ago",
        defaultMessage: "{dayCount, plural, one {{dayCount} day ago} other {{dayCount} days ago}}"
    },
    weeksAgo: {
        id: "macro-utils.relative-time-weeks-ago",
        defaultMessage: "{weekCount, plural, one {{weekCount} week ago} other {{weekCount} weeks ago}}"
    },
    monthsAgo: {
        id: "macro-utils.relative-time-months-ago",
        defaultMessage: "{monthCount, plural, one {{monthCount} month ago} other {{monthCount} months ago}}"
    },
    yearsAgo: {
        id: "macro-utils.relative-time-years-ago",
        defaultMessage: "{yearCount, plural, one {{yearCount} year ago} other {{yearCount} years ago}}"
    },
    justAMomentAgo: {
        id: "macro-utils.relative-time-just-a-moment-ago",
        defaultMessage: "just a moment ago"
    },
    lessThanAMinuteAgo: {
        id: "macro-utils.relative-time-less-than-a-minute-ago",
        defaultMessage: "less than a minute ago"
    },
    aMinuteAgo: {
        id: "macro-utils.relative-time-a-minute-ago",
        defaultMessage: "a minute ago"
    },
    contentReportMinutesAgo: {
        id: "macro-utils.content-report-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    aboutAnHourAgo: {
        id: "macro-utils.relative-time-about-an-hour-ago",
        defaultMessage: "about an hour ago"
    },
    contentReportHoursAgo: {
        id: "macro-utils.content-report-hours-ago",
        defaultMessage: "{hourCount, plural, one {about {hourCount} hour ago} other {about {hourCount} hours ago}}"
    },
    yesterdayAt: {
        id: "macro-utils.relative-time-yesterday-at",
        defaultMessage: "yesterday at {time}"
    }
});
const $dce38ffecfe5cc1b$var$formatBucketMessage = (bucket, diffMs, intl)=>{
    if (bucket.valueName && bucket.unitMs) {
        const count = bucket.countCalculator ? bucket.countCalculator(diffMs) : Math.floor(diffMs / bucket.unitMs);
        return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message], {
            [bucket.valueName]: count
        });
    }
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message]);
};
const $dce38ffecfe5cc1b$export$bfc1ce7d5853041b = {
    buckets: [
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'justNow'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$HOUR,
            message: 'minutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'hoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$WEEK,
            message: 'daysAgo',
            valueName: 'dayCount',
            unitMs: $dce38ffecfe5cc1b$var$DAY
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MONTH,
            message: 'weeksAgo',
            valueName: 'weekCount',
            unitMs: $dce38ffecfe5cc1b$var$WEEK
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$YEAR,
            message: 'monthsAgo',
            valueName: 'monthCount',
            unitMs: $dce38ffecfe5cc1b$var$MONTH
        },
        {
            maxDiffMs: Number.POSITIVE_INFINITY,
            message: 'yearsAgo',
            valueName: 'yearCount',
            unitMs: $dce38ffecfe5cc1b$var$YEAR
        }
    ]
};
const $dce38ffecfe5cc1b$export$409646d2c0c56892 = {
    buckets: [
        {
            maxDiffMs: 4000,
            message: 'justAMomentAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'lessThanAMinuteAgo'
        },
        {
            maxDiffMs: 2 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aMinuteAgo'
        },
        {
            maxDiffMs: 50 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'contentReportMinutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$MINUTE)
        },
        {
            maxDiffMs: 90 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aboutAnHourAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'contentReportHoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$HOUR)
        }
    ],
    specialCase: ({ timestampMs: timestampMs, nowMs: nowMs, diffMs: diffMs, intl: intl })=>{
        const savedTime = new Date(timestampMs);
        const now = new Date(nowMs);
        if ($dce38ffecfe5cc1b$export$221990270ebfe867(savedTime, now) && diffMs > 5 * $dce38ffecfe5cc1b$var$HOUR) return $dce38ffecfe5cc1b$export$fc16bfc40f160b09(savedTime, intl);
        return null;
    },
    fallback: ({ timestampMs: timestampMs })=>$dce38ffecfe5cc1b$export$359f3c271cd167e3(new Date(timestampMs))
};
const $dce38ffecfe5cc1b$export$e22324fe17cb0dfe = (timestamp, intl, config)=>{
    const nowMs = Date.now();
    const diffMs = nowMs - timestamp;
    if (config.specialCase) {
        const specialResult = config.specialCase({
            timestampMs: timestamp,
            nowMs: nowMs,
            diffMs: diffMs,
            intl: intl
        });
        if (specialResult !== null) return specialResult;
    }
    for (const bucket of config.buckets){
        if (diffMs < bucket.maxDiffMs) return $dce38ffecfe5cc1b$var$formatBucketMessage(bucket, diffMs, intl);
    }
    if (config.fallback) return config.fallback({
        timestampMs: timestamp,
        nowMs: nowMs,
        diffMs: diffMs,
        intl: intl
    });
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
};
const $dce38ffecfe5cc1b$export$493c11ff22f45a24 = (timestamp, intl)=>{
    const now = Date.now();
    const diff = now - timestamp;
    if (diff < $dce38ffecfe5cc1b$var$MINUTE) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
    else if (diff < $dce38ffecfe5cc1b$var$HOUR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.minutesAgo, {
        minuteCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MINUTE)
    });
    else if (diff < $dce38ffecfe5cc1b$var$DAY) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.hoursAgo, {
        hourCount: Math.floor(diff / $dce38ffecfe5cc1b$var$HOUR)
    });
    else if (diff < $dce38ffecfe5cc1b$var$WEEK) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.daysAgo, {
        dayCount: Math.floor(diff / $dce38ffecfe5cc1b$var$DAY)
    });
    else if (diff < $dce38ffecfe5cc1b$var$MONTH) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.weeksAgo, {
        weekCount: Math.floor(diff / $dce38ffecfe5cc1b$var$WEEK)
    });
    else if (diff < $dce38ffecfe5cc1b$var$YEAR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.monthsAgo, {
        monthCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MONTH)
    });
    else return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yearsAgo, {
        yearCount: Math.floor(diff / $dce38ffecfe5cc1b$var$YEAR)
    });
};
const $dce38ffecfe5cc1b$export$221990270ebfe867 = (date, now)=>{
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    return yesterday.toLocaleDateString() === date.toLocaleDateString();
};
const $dce38ffecfe5cc1b$export$fc16bfc40f160b09 = (date, intl)=>{
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yesterdayAt, {
        time: $dce38ffecfe5cc1b$export$5a00511f040384d7.format(date)
    });
};
const $dce38ffecfe5cc1b$export$359f3c271cd167e3 = (date)=>{
    return $dce38ffecfe5cc1b$export$406508d2ca449bd.format(date);
};
const $dce38ffecfe5cc1b$export$505b35374c01d686 = (timestamp, intl)=>{
    return $dce38ffecfe5cc1b$export$e22324fe17cb0dfe(timestamp, intl, $dce38ffecfe5cc1b$export$409646d2c0c56892);
};
module.exports["getRelativeTime"] = $dce38ffecfe5cc1b$export$493c11ff22f45a24;
module.exports["formatContentReportEpochTime"] = $dce38ffecfe5cc1b$export$505b35374c01d686;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});


//# sourceMappingURL=BlogPostsMacroRenderer.c8994fb4.js.map
